import React from 'react';

// eslint-disable-next-line no-unused-vars
import Chart from './Chart.bundle.js';

import { _initBarChart, _clearBarChart} from '../html/BarChart/BarChart.js'

class MagstimBarChart extends React.Component {

    constructor() {
        super();
        this._canvasRef = React.createRef();
    }

    init(data, onClickBar, max) {
        _initBarChart(this.props.chartCanvasName, data, 14, onClickBar, this.props.suggestedMax, max);     
    }

    
    componentWillUnmount() {
        _clearBarChart(this.props.chartCanvasName);
    }

    render() {
        var content = <div className={"ui-panel d-block pt-3 pb-3"} >
            <canvas style={{ width: this.props.width, height: this.props.height }} ref={this._canvasRef} id={this.props.chartCanvasName} />
        </div>;

        return (
            <>
                {content}
            </>
        );
    }
}

export default MagstimBarChart;